import { useOrg } from './OrgContext';

export default function OrgSwitcher() {
  const { organizations, currentOrgId, setCurrentOrgId } = useOrg();

  if (organizations.length === 0) {
    return <span className="muted">No organizations</span>;
  }

  return (
    <select
      className="org-switcher"
      value={currentOrgId ?? ''}
      onChange={e => setCurrentOrgId(e.target.value)}
      aria-label="Switch organization"
    >
      {organizations.map(o => (
        <option key={o.id} value={o.id}>
          {o.displayName ?? o.githubAccountLogin}
          {o.role !== 'MEMBER' ? ` (${o.role.toLowerCase()})` : ''}
        </option>
      ))}
    </select>
  );
}
